<template>
  <div>
    <yx-auto-complete
      :width="width"
      :api="api.allTeacherList"
      :placeholder="placeholder"
      :no-page="true"
      :keys="{ searchKey: 'queryKey' }"
      :query-params="{ scene: 0 }"
      :display-format="displayFormat"
      :immediate="immediate"
      @select="(arg) => $emit('select', arg)"
      @clear="() => $emit('clear')"
      ref="yxRef"
    />
  </div>
</template>

<script>
import { defineComponent, ref } from 'vue';

export default defineComponent({
  props: {
    width: {
      type: String,
      default: '320px',
    },
    placeholder: {
      type: String,
      default: '老师姓名/手机号码',
    },
    format: Boolean,
    immediate: {
      type: Boolean,
      default: true,
    },
  },
  setup(props) {
    const yxRef = ref(null);
    return {
      yxRef,
      displayFormat(it) {
        const item = it;
        if (props.format) {
          return `${item.name}-${item.phone}`;
        }
        return `${item.name}`;
      },
      clearField() {
        yxRef.value.clearField();
      },
      setField(str) {
        yxRef.value.setField(str);
      },
    };
  },
});
</script>
